import { gql } from 'apollo-boost'

const COMPLETED_MENU_PROBING_JOBS_FOR_MENU = gql`
  query completedMenuProbingJobsForMenu($menuId: ID!) {
    completedMenuProbingJobsForMenu(menuId: $menuId) {
      id
      completedDate
      probingStatus
    }
  }
`

export default COMPLETED_MENU_PROBING_JOBS_FOR_MENU
